import { createContext } from 'react'

export const noProfile = {
    id: '',
    name: '',
    picUri: '/anonymous.png',
}

export const ProfileContext = createContext(noProfile)
